<div class="ai-image-modal" [class.redesign]="isRedesign">
  <div class="modal-header-row">
    <h4 id="ai-image-modal-title">AI Image Generator</h4>
    <button (click)="close()" type="button" class="close-button" aria-label="Close AI image generator">
      <img src="assets/cb/images/close-icon.png" alt="" />
    </button>
  </div>
  <p id="ai-image-modal-intro" class="intro">
    Generate a raster image for use in your design. Best for backgrounds, patterns, and decorative graphics.<br>
    Avoid relying on AI for important text, logos, or critical details.
  </p>

  <form (ngSubmit)="generateImage()" aria-labelledby="ai-image-modal-title" aria-describedby="ai-image-modal-intro" novalidate>

    <div class="form-group prompts">
      <div class="prompt-input-column">
        <label class="form-section-heading" for="ai-image-prompt">Prompt</label>
        <p id="ai-image-prompt-help" class="field-help nomrg">Describe the artwork to generate.</p>
        <p id="ai-image-prompt-warning" class="field-help nomrg">Avoid logos, small text, copyrighted characters, or critical brand marks.</p>
        <textarea
          #promptTextarea
          id="ai-image-prompt"
          name="prompt"
          [(ngModel)]="prompt"
          [placeholder]="promptPlaceholder"
          [disabled]="isGenerating"
          [attr.aria-describedby]="promptDescribedBy"
          [attr.aria-invalid]="showPromptError ? 'true' : null"
          (keydown)="onPromptKeydown($event)"
          autocomplete="off"
          rows="2"
        ></textarea>
        @if (showPromptError) {
          <p id="ai-image-prompt-error" class="field-error" role="alert">Prompt is required. Enter a short description before generating.</p>
        }
      </div>
    </div>

    <div class="form-group">
      <label class="form-section-heading" id="ai-image-aspect-ratio-label">{{aspectRatioLabel}}</label>
      <p id="ai-image-aspect-ratio-help" class="field-help nomrg">{{aspectRatioHelpText}}</p>
      <mat-select
        id="ai-image-aspect-ratio"
        name="aspectRatio"
        [(ngModel)]="selectedAspectRatio"
        aria-labelledby="ai-image-aspect-ratio-label"
        aria-describedby="ai-image-aspect-ratio-help"
        [disabled]="isGenerating">
        @for (option of aspectRatioOptions; track trackByAspectRatio($index, option)) {
          <mat-option [value]="option.value">
            <span class="shape-option">
              <span class="shape-thumbnail-frame">
                <span class="shape-thumbnail" [ngClass]="getShapePreviewClass(option)"></span>
              </span>
              <span>{{option.label}}</span>
            </span>
          </mat-option>
        }
      </mat-select>
    </div>

    @if (isGenerating) {
      <p class="loading-message" role="status" aria-live="polite">
        Generating image
      </p>
    }

    @if (errorMessage) {
      <p class="error-message mb-2" role="alert">{{errorMessage}}</p>
    }

    @if (generatedImage) {
      <div class="generated-preview" role="region" aria-labelledby="ai-image-preview-heading">
        <div class="preview-copy" aria-live="polite">
          <h5 id="ai-image-preview-heading">Generated preview</h5>
          <p>Review this result before adding it to the designer.</p>
        </div>
        <div class="preview-image-frame">
          <img [src]="generatedImage.src" alt="Generated image preview">
        </div>
      </div>
    }

    <div class="button-row">
      <button type="submit" class="primary-action" [class.secondary-action]="generatedImage" [disabled]="isGenerating">
        @if (isGenerating) {
          <span>GENERATING...</span>
        } @else if (generatedImage) {
          <span>GENERATE AGAIN</span>
        } @else {
          <span>GENERATE IMAGE</span>
        }
      </button>
      @if (conversationId || generatedImage) {
        <button type="button" class="secondary-action" (click)="startOver()" [disabled]="isGenerating">
          START OVER
        </button>
      }
      @if (generatedImage) {
        <button type="button" class="primary-action" (click)="addPreviewToDesign()" [disabled]="isGenerating">
          ADD TO DESIGN
        </button>
      }
    </div>
  </form>
</div>
